export const PROD_EMARSYS_PARAMS = {
  email: 3,
  optin: 31,
  subscribeSource: 15048,
  marketingEmailSubscriber: 11198,
  country: 15049,
  language: 15199,
  contactListId: 713034644,
  doubleOptInFlag: 12776
}

export const DEV_EMARSYS_PARAMS = {
  email: 3,
  optin: 31,
  subscribeSource: 15044,
  marketingEmailSubscriber: 9270,
  country: 15046,
  language: 15198,
  contactListId: 1623765360,
  doubleOptInFlag: 12161
}

export const EMARSYS_LANGUAGES: Record<string, number> = {
  lv: 1,
  lt: 2,
  et: 3,
  fi: 4,
  no: 5,
  se: 6,
  ru: 7,
  de: 8,
  other: 9,
  en: 10
}

export const EMARSYS_COUNTRIES: Record<string, number | null> = {
  LV: 95,
  EE: 57,
  LT: 101,
  AT: 10,
  BE: 17,
  CZ: 47,
  DK: 48,
  FI: 60,
  FR: 61,
  GB: 184,
  GE: 64,
  DE: 65,
  GR: 67,
  IL: 82,
  IT: 83,
  NL: 124,
  NO: 129,
  PL: 139,
  PT: 140,
  ES: 162,
  SE: 167,
  CH: 168,
  TR: 178,
  UA: 182,
  AE: 183,
  UK: 184,
  ZZ: null
}

export const EMARSYS_PUSH_RETRY_AT_STORAGE_KEY = 'emarsys_push_retry_at'
export const EMARSYS_PUSH_RETRY_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000
